import { downloadReport } from "../../asset";

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

export default function DownloadButton({
  onClick,
  disabled,
}: Props) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-2 px-3 py-[6px] rounded 
                 bg-success-800 text-white text-[13px] font-semibold
                 hover:bg-success-700 disabled:opacity-50"
    >
      <img src={downloadReport} alt="" />
      Report
    </button>
  );
}
